import React from 'react';
import SectionCard from './SectionCard';
import { RadioGroup, RadioGroupItem } from '../../../components/ui/radio-group';

const SpecialLeviesSection = ({ submission, jsonContent, isDark }) => {
    if (submission.recipient_source === 'non-strata' || !(submission.specialLeviesResolved || jsonContent.specialLeviesResolved)) {
        return null;
    }

    return (
        <SectionCard isDark={isDark}>
            <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>Were special levies resolved? <span className='text-red-500'>*</span></p>
            <RadioGroup value={submission.specialLeviesResolved || jsonContent.specialLeviesResolved}>
                <div className='flex flex-col gap-[14px]'>
                    {(submission.specialLeviesResolved === 'no' || jsonContent.specialLeviesResolved === 'no') && (
                        <div className='flex gap-[8px] items-center'>
                            <RadioGroupItem value="no" id="specialLevies-no" />
                            <label htmlFor="specialLevies-no" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                isDark ? 'text-white' : 'text-[#072837]'
                            }`}>No</label>
                        </div>
                    )}
                    {(submission.specialLeviesResolved === 'yes' || jsonContent.specialLeviesResolved === 'yes') && (
                        <div className='flex gap-[8px] items-center'>
                            <RadioGroupItem value="yes" id="specialLevies-yes" />
                            <label htmlFor="specialLevies-yes" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                isDark ? 'text-white' : 'text-[#072837]'
                            }`}>Yes</label>
                        </div>
                    )}
                </div>
            </RadioGroup>

            {/* Motion description (conditional) */}
            {(submission.specialLeviesResolved === 'yes' || jsonContent.specialLeviesResolved === 'yes') &&
                (submission.specialLeviesMotion || jsonContent.specialLeviesMotion) && (
                <div className='flex flex-col gap-[8px]'>
                    <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>What Motion?</p>
                    <input
                        className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                            isDark ? 'bg-[#161515] text-white' : 'bg-[#f5f5f5] text-[#072837]'
                        }`}
                        type="text"
                        value={submission.specialLeviesMotion || jsonContent.specialLeviesMotion || ''}
                        readOnly
                    />
                </div>
            )}
            
            {(submission.specialLeviesResolved === 'yes' || jsonContent.specialLeviesResolved === 'yes') &&
                (submission.specialLeviesNotes || jsonContent.specialLeviesNotes) && (
                <div className='flex flex-col gap-[8px]'>
                    <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>Any notes for Levies Team</p>
                    <textarea
                        className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent resize-none ${
                            isDark ? 'bg-[#161515] text-white' : 'bg-[#f5f5f5] text-[#072837]'
                        }`}
                        rows={3}
                        value={submission.specialLeviesNotes || jsonContent.specialLeviesNotes || ''}
                        readOnly
                    />
                </div>
            )}
        </SectionCard>
    );
};

export default SpecialLeviesSection;
